
import api from "@/services/api"
import { Tag } from "@/types/Tag"

class ApiTag {
    private axios: any;
    public constructor (axios: any) { this.axios = axios }

    public async tagList (): Promise<Tag[]> { return (await this.axios.get("/tags")).data }
    public async tagSave (tag: Tag): Promise<string> { return (await this.axios.post("/tags", tag)).data }
    public async tagDelete (tag: Tag): Promise<void> { await this.axios.delete(`/tags/${tag.id}`) }
}

const apiTag = new ApiTag(api.getAxios())
export default apiTag
